/**
 * ErrorState.jsx - Error Display Component
 * Phase 3B - Named export only
 */

import React from 'react';
import { X } from 'lucide-react';

export const ErrorState = ({ message, onRetry }) => (
  <div className="flex flex-col items-center justify-center py-12 px-4">
    <div className="w-12 h-12 rounded-full bg-red-100 flex items-center justify-center mb-3">
      <X size={24} className="text-red-500" />
    </div>
    <p className="text-sm text-red-600 text-center mb-3">{message}</p>
    {onRetry && (
      <button onClick={onRetry} className="text-sm text-indigo-600 font-medium">
        Try Again
      </button>
    )}
  </div>
);
